import React from 'react'

type Props = {
  iconSize?: number
  className?: string
}

const GooglePlayIcon = ({ iconSize = 24, className }: Props) => {
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4.81354 19.6099C4.56935 19.488 4.44727 19.1831 4.44727 18.8782C4.44727 18.8172 4.44727 18.6953 4.44727 18.6343C4.44727 14.1221 4.44727 9.60987 4.44727 5.15863C4.44727 4.91473 4.50831 4.73182 4.56935 4.48791C4.63042 4.36594 4.7525 4.24401 4.87461 4.12207C7.49965 6.74402 10.0636 9.36597 12.6277 11.988C10.0026 14.427 7.43861 16.988 4.81354 19.6099Z"
        fill="white"
        fillOpacity="0.9"
      />
      <path
        d="M15.1904 9.3049C14.4579 10.0366 13.6643 10.7683 12.9317 11.561C10.4898 9.06099 7.98683 6.56098 5.54492 4.06097C5.54492 4.06097 5.54492 4 5.60596 4C8.78046 5.76829 11.9549 7.53661 15.1904 9.3049Z"
        fill="white"
        fillOpacity="0.9"
      />
      <path
        d="M5.54492 19.6096C7.98683 17.1706 10.4898 14.7315 12.9317 12.2925C13.6032 12.9632 14.3358 13.634 15.1294 14.3656C11.9549 16.134 8.78046 17.9023 5.60596 19.6096H5.54492Z"
        fill="white"
        fillOpacity="0.9"
      />
      <path
        d="M15.5581 14.1215C14.7644 13.3899 14.0319 12.6581 13.2383 11.9264C14.0319 11.1337 14.8255 10.341 15.6191 9.54834C15.8633 9.67027 16.1074 9.79225 16.3517 9.97515C16.9621 10.341 17.6337 10.6459 18.2442 11.0118C18.4273 11.0727 18.5494 11.1947 18.6714 11.3776C18.9157 11.6824 18.9157 11.9874 18.6714 12.2923C18.5494 12.4142 18.4273 12.5362 18.2442 12.5971C17.3895 13.1459 16.4738 13.6337 15.5581 14.1215Z"
        fill="white"
        fillOpacity="0.9"
      />
    </svg>
  )
}

export default GooglePlayIcon
